var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-10", attrs: { id: "wizard" } },
    [
      _c(
        "v-overlay",
        {
          attrs: {
            color: "#000",
            opacity: "0.40",
            absolute: true,
            value: _vm.isLoading,
            "z-index": 3
          }
        },
        [
          _c("v-progress-circular", {
            staticClass: "mr-10px",
            attrs: { indeterminate: "", color: "primary", size: 60, width: 5 }
          }),
          !_vm.isSaving
            ? _c("span", [
                _vm._v("Prebieha načítanie dát, prosím počkajte ...")
              ])
            : _vm._e(),
          _vm.isSaving
            ? _c("span", [
                _vm._v("Prebieha ukladanie dát, prosím počkajte ...")
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-container",
        { staticClass: "pa-0" },
        [
          _c("h1", { staticClass: "mt-45px mb-28px" }, [
            _vm._v("Preberací protokol")
          ]),
          _c(
            "v-card",
            { staticClass: "card" },
            [
              _c(
                "v-form",
                { ref: "formBasicInfo", attrs: { autocomplete: "off" } },
                [
                  _c("h2", { staticClass: "mb-6" }, [
                    _vm._v("Základné informácie o predmete")
                  ]),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "datum_prvej_platby")
                            ? _c("date-picker", {
                                attrs: {
                                  label: "Dátum prvej platby",
                                  placeholder: "DD/MM/YYYY",
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "datum_prvej_platby"
                                  ),
                                  isEnabled: _vm.getParameter(
                                    "isEnabled",
                                    "datum_prvej_platby"
                                  )
                                },
                                model: {
                                  value:
                                    _vm.preberaciProtokol.datum_prvej_platby,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "datum_prvej_platby",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "preberaciProtokol.datum_prvej_platby"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "datum_prebratia")
                            ? _c("date-picker", {
                                attrs: {
                                  label: "Dátum prebratia",
                                  placeholder: "DD/MM/YYYY",
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "datum_prebratia"
                                  ),
                                  isEnabled: _vm.getParameter(
                                    "isEnabled",
                                    "datum_prebratia"
                                  )
                                },
                                model: {
                                  value: _vm.preberaciProtokol.datum_prebratia,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "datum_prebratia",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "preberaciProtokol.datum_prebratia"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("button-group", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.getParameter(
                                  "isDisplayed",
                                  "ojazdene_vozidlo"
                                ),
                                expression:
                                  "getParameter('isDisplayed', 'ojazdene_vozidlo')"
                              }
                            ],
                            class: {
                              required: _vm.getParameter(
                                "isRequired",
                                "ojazdene_vozidlo"
                              )
                            },
                            attrs: {
                              switchBtn: "",
                              dynamic: false,
                              items: _vm.jazdenyItems,
                              isEnabled: _vm.getParameter(
                                "isEnabled",
                                "ojazdene_vozidlo"
                              ),
                              rules: _vm.getParameter(
                                "isRequired",
                                "ojazdene_vozidlo"
                              )
                                ? _vm.requiredRule
                                : []
                            },
                            model: {
                              value: _vm.preberaciProtokol.ojazdene_vozidlo,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.preberaciProtokol,
                                  "ojazdene_vozidlo",
                                  $$v
                                )
                              },
                              expression: "preberaciProtokol.ojazdene_vozidlo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "id_druhu_tovaru")
                            ? _c("v-autocomplete", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "id_druhu_tovaru"
                                  )
                                },
                                attrs: {
                                  "append-icon": "mdi-chevron-down",
                                  outlined: "",
                                  label: "Druh predmetu",
                                  items: _vm.druhyTovaruData,
                                  "item-text": "displayMember",
                                  "item-value": "valueMember",
                                  disabled: !_vm.getParameter(
                                    "isEnabled",
                                    "id_druhu_tovaru"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "id_druhu_tovaru"
                                  )
                                    ? _vm.requiredRule
                                    : []
                                },
                                model: {
                                  value: _vm.preberaciProtokol.id_druhu_tovaru,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "id_druhu_tovaru",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "preberaciProtokol.id_druhu_tovaru"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "8" } },
                        [
                          _vm.getParameter("isDisplayed", "ma_overeny_pp")
                            ? _c("v-checkbox", {
                                staticClass: "dynamic_check_box mt-0 pt-0",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "ma_overeny_pp"
                                  )
                                },
                                attrs: {
                                  label: "Fyzicky overený",
                                  disabled: !_vm.getParameter(
                                    "isEnabled",
                                    "ma_overeny_pp"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "ma_overeny_pp"
                                  )
                                    ? _vm.requiredRule
                                    : [],
                                  "false-value": 0,
                                  "true-value": 1,
                                  "hide-details": "",
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.preberaciProtokol.ma_overeny_pp,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "ma_overeny_pp",
                                      $$v
                                    )
                                  },
                                  expression: "preberaciProtokol.ma_overeny_pp"
                                }
                              })
                            : _vm._e(),
                          _vm.getParameter(
                            "isDisplayed",
                            "podlieha_evidencii_na_di"
                          )
                            ? _c("v-checkbox", {
                                staticClass: "dynamic_check_box mt-0 pt-2",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "podlieha_evidencii_na_di"
                                  )
                                },
                                attrs: {
                                  label:
                                    "Predmet sa bude registrovať na Dopravnom inšpektoráte",
                                  disabled: !_vm.getParameter(
                                    "isEnabled",
                                    "podlieha_evidencii_na_di"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "podlieha_evidencii_na_di"
                                  )
                                    ? _vm.requiredRule
                                    : [],
                                  "false-value": 0,
                                  "true-value": 1,
                                  "hide-details": "",
                                  outlined: ""
                                },
                                model: {
                                  value:
                                    _vm.preberaciProtokol
                                      .podlieha_evidencii_na_di,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "podlieha_evidencii_na_di",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "preberaciProtokol.podlieha_evidencii_na_di"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "8" } },
                        [
                          _vm.getParameter("isDisplayed", "nazov")
                            ? _c("v-text-field", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "nazov"
                                  )
                                },
                                attrs: {
                                  label: "Názov predmetu",
                                  disabled: !_vm.getParameter(
                                    "isEnabled",
                                    "nazov"
                                  ),
                                  rules: _vm.getParameter("isRequired", "nazov")
                                    ? _vm.requiredRule
                                    : [],
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.preberaciProtokol.nazov,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "nazov",
                                      $$v
                                    )
                                  },
                                  expression: "preberaciProtokol.nazov"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "8" } },
                        [
                          _vm.getParameter("isDisplayed", "specifikacia")
                            ? _c("v-textarea", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "specifikacia"
                                  )
                                },
                                attrs: {
                                  label: "Špecifikácia",
                                  disabled: !_vm.getParameter(
                                    "isEnabled",
                                    "specifikacia"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "specifikacia"
                                  )
                                    ? _vm.requiredRule
                                    : [],
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.preberaciProtokol.specifikacia,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "specifikacia",
                                      $$v
                                    )
                                  },
                                  expression: "preberaciProtokol.specifikacia"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter(
                            "isDisplayed",
                            "datum_vystavenia_oev"
                          )
                            ? _c("date-picker", {
                                attrs: {
                                  label: "Termín vystavenia OEV",
                                  placeholder: "DD/MM/YYYY",
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "datum_vystavenia_oev"
                                  ),
                                  isEnabled: _vm.getParameter(
                                    "isEnabled",
                                    "datum_vystavenia_oev"
                                  )
                                },
                                model: {
                                  value:
                                    _vm.preberaciProtokol.datum_vystavenia_oev,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "datum_vystavenia_oev",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "preberaciProtokol.datum_vystavenia_oev"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "datum_dodania_oev")
                            ? _c("date-picker", {
                                attrs: {
                                  label: "Termín dodania OEV",
                                  placeholder: "DD/MM/YYYY",
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "datum_dodania_oev"
                                  ),
                                  isEnabled: _vm.getParameter(
                                    "isEnabled",
                                    "datum_dodania_oev"
                                  )
                                },
                                model: {
                                  value:
                                    _vm.preberaciProtokol.datum_dodania_oev,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "datum_dodania_oev",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "preberaciProtokol.datum_dodania_oev"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "vyrobne_cislo")
                            ? _c("v-text-field", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "vyrobne_cislo"
                                  )
                                },
                                attrs: {
                                  label: "Číslo karosérie/VIN",
                                  loading: _vm.vinLoading,
                                  disabled: !_vm.getParameter(
                                    "isEnabled",
                                    "vyrobne_cislo"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "vyrobne_cislo"
                                  )
                                    ? [_vm.requiredRule[0], _vm.vinUsedRule]
                                    : [_vm.vinUsedRule],
                                  outlined: ""
                                },
                                on: {
                                  focusout: function($event) {
                                    return _vm.checkVin(true)
                                  }
                                },
                                model: {
                                  value: _vm.preberaciProtokol.vyrobne_cislo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "vyrobne_cislo",
                                      $$v
                                    )
                                  },
                                  expression: "preberaciProtokol.vyrobne_cislo"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "znacka")
                            ? _c("v-text-field", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "znacka"
                                  )
                                },
                                attrs: {
                                  outlined: "",
                                  label: "Značka",
                                  disabled: !_vm.getParameter(
                                    "isEnabled",
                                    "znacka"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "znacka"
                                  )
                                    ? _vm.requiredRule
                                    : []
                                },
                                model: {
                                  value: _vm.preberaciProtokol.znacka,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "znacka",
                                      $$v
                                    )
                                  },
                                  expression: "preberaciProtokol.znacka"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "model")
                            ? _c("v-text-field", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "model"
                                  )
                                },
                                attrs: {
                                  outlined: "",
                                  label: "Model",
                                  disabled: !_vm.getParameter(
                                    "isEnabled",
                                    "model"
                                  ),
                                  rules: _vm.getParameter("isRequired", "model")
                                    ? _vm.requiredRule
                                    : []
                                },
                                model: {
                                  value: _vm.preberaciProtokol.model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "model",
                                      $$v
                                    )
                                  },
                                  expression: "preberaciProtokol.model"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "verzia_modelu")
                            ? _c("v-text-field", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "verzia_modelu"
                                  )
                                },
                                attrs: {
                                  outlined: "",
                                  label: "Verzia modelu",
                                  disabled: !_vm.getParameter(
                                    "isEnabled",
                                    "verzia_modelu"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "verzia_modelu"
                                  )
                                    ? _vm.requiredRule
                                    : []
                                },
                                model: {
                                  value: _vm.preberaciProtokol.verzia_modelu,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "verzia_modelu",
                                      $$v
                                    )
                                  },
                                  expression: "preberaciProtokol.verzia_modelu"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter(
                            "isDisplayed",
                            "cennikova_cena_s_dph"
                          )
                            ? _c("numeric-text-box", {
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "cennikova_cena_s_dph"
                                  )
                                },
                                attrs: {
                                  label: "Cenníková cena",
                                  suffix: "€",
                                  isEnabled: _vm.getParameter(
                                    "isEnabled",
                                    "cennikova_cena_s_dph"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "cennikova_cena_s_dph"
                                  )
                                    ? _vm.requiredRule
                                    : []
                                },
                                model: {
                                  value:
                                    _vm.preberaciProtokol.cennikova_cena_s_dph,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "cennikova_cena_s_dph",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "preberaciProtokol.cennikova_cena_s_dph"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "vykon_motora")
                            ? _c("numeric-text-box", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "vykon_motora"
                                  )
                                },
                                attrs: {
                                  label: "Výkon motora",
                                  outlined: "",
                                  suffix: "kW",
                                  decimalPlaces: 0,
                                  isEnabled: _vm.getParameter(
                                    "isEnabled",
                                    "vykon_motora"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "vykon_motora"
                                  )
                                    ? _vm.requiredRule
                                    : []
                                },
                                model: {
                                  value: _vm.preberaciProtokol.vykon_motora,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "vykon_motora",
                                      $$v
                                    )
                                  },
                                  expression: "preberaciProtokol.vykon_motora"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "objem_motora")
                            ? _c("numeric-text-box", {
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "objem_motora"
                                  )
                                },
                                attrs: {
                                  label: "Objem motora",
                                  decimalPlaces: 0,
                                  isEnabled: _vm.getParameter(
                                    "isEnabled",
                                    "objem_motora"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "objem_motora"
                                  )
                                    ? _vm.requiredRule
                                    : []
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "append",
                                      fn: function() {
                                        return [
                                          _vm._v("cm"),
                                          _c(
                                            "sup",
                                            { staticStyle: { top: "-0.2em" } },
                                            [_vm._v("3")]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  858059466
                                ),
                                model: {
                                  value: _vm.preberaciProtokol.objem_motora,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "objem_motora",
                                      $$v
                                    )
                                  },
                                  expression: "preberaciProtokol.objem_motora"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "pociatocny_stav_km")
                            ? _c("numeric-text-box", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "pociatocny_stav_km"
                                  )
                                },
                                attrs: {
                                  label: "Počiatočný stav",
                                  outlined: "",
                                  suffix: "km",
                                  decimalPlaces: 0,
                                  isEnabled: _vm.getParameter(
                                    "isEnabled",
                                    "pociatocny_stav_km"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "pociatocny_stav_km"
                                  )
                                    ? _vm.requiredRule
                                    : []
                                },
                                model: {
                                  value:
                                    _vm.preberaciProtokol.pociatocny_stav_km,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "pociatocny_stav_km",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "preberaciProtokol.pociatocny_stav_km"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "hmotnost_celkova")
                            ? _c("numeric-text-box", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "hmotnost_celkova"
                                  )
                                },
                                attrs: {
                                  label: "Celková hmotnosť",
                                  outlined: "",
                                  suffix: "kg",
                                  decimalPlaces: 0,
                                  isEnabled: _vm.getParameter(
                                    "isEnabled",
                                    "hmotnost_celkova"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "hmotnost_celkova"
                                  )
                                    ? _vm.requiredRule
                                    : []
                                },
                                model: {
                                  value: _vm.preberaciProtokol.hmotnost_celkova,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "hmotnost_celkova",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "preberaciProtokol.hmotnost_celkova"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "rok_vyroby")
                            ? _c("v-text-field", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "rok_vyroby"
                                  )
                                },
                                attrs: {
                                  label: "Rok výroby",
                                  outlined: "",
                                  disabled: !_vm.getParameter(
                                    "isEnabled",
                                    "rok_vyroby"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "rok_vyroby"
                                  )
                                    ? _vm.requiredRule
                                    : []
                                },
                                model: {
                                  value: _vm.preberaciProtokol.rok_vyroby,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "rok_vyroby",
                                      $$v
                                    )
                                  },
                                  expression: "preberaciProtokol.rok_vyroby"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "datum_1_evidencie")
                            ? _c("date-picker", {
                                attrs: {
                                  label: "Dátum prvej registrácie",
                                  placeholder: "DD/MM/YYYY",
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "datum_1_evidencie"
                                  ),
                                  isEnabled: _vm.getParameter(
                                    "isEnabled",
                                    "datum_1_evidencie"
                                  )
                                },
                                model: {
                                  value:
                                    _vm.preberaciProtokol.datum_1_evidencie,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "datum_1_evidencie",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "preberaciProtokol.datum_1_evidencie"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "pocet_naprav")
                            ? _c("numeric-text-box", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "pocet_naprav"
                                  )
                                },
                                attrs: {
                                  label: "Počet náprav",
                                  outlined: "",
                                  decimalPlaces: 0,
                                  isEnabled: _vm.getParameter(
                                    "isEnabled",
                                    "pocet_naprav"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "pocet_naprav"
                                  )
                                    ? _vm.requiredRule
                                    : []
                                },
                                model: {
                                  value: _vm.preberaciProtokol.pocet_naprav,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "pocet_naprav",
                                      $$v
                                    )
                                  },
                                  expression: "preberaciProtokol.pocet_naprav"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _vm.getParameter("isDisplayed", "typ_motora")
                            ? _c("v-autocomplete", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getParameter(
                                    "isRequired",
                                    "typ_motora"
                                  )
                                },
                                attrs: {
                                  "append-icon": "mdi-chevron-down",
                                  outlined: "",
                                  label: "Palivo",
                                  items: _vm.typyMotoraData,
                                  "item-text": "displayMember",
                                  "item-value": "valueMember",
                                  disabled: !_vm.getParameter(
                                    "isEnabled",
                                    "typ_motora"
                                  ),
                                  rules: _vm.getParameter(
                                    "isRequired",
                                    "typ_motora"
                                  )
                                    ? _vm.requiredRule
                                    : []
                                },
                                model: {
                                  value: _vm.preberaciProtokol.typ_motora,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.preberaciProtokol,
                                      "typ_motora",
                                      $$v
                                    )
                                  },
                                  expression: "preberaciProtokol.typ_motora"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.jeAuto === false
            ? _c(
                "div",
                _vm._l(_vm.preberaciProtokolTechnologie, function(tech, index) {
                  return _c(
                    "v-card",
                    {
                      key: index,
                      staticClass: "mt-24px card",
                      attrs: { id: "technologia" + tech.pkid }
                    },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form" + tech.pkid,
                          refInFor: true,
                          attrs: { autocomplete: "off" }
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c("v-col", { attrs: { cols: "11" } }, [
                                _c("h2", [_vm._v(_vm._s(tech.nazov_predmetu))])
                              ]),
                              _c(
                                "v-col",
                                { attrs: { cols: "1" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn-secondary right",
                                      attrs: { icon: "" },
                                      on: {
                                        click: function($event) {
                                          tech.active = !tech.active
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          class: { "rotate-180": tech.active }
                                        },
                                        [_vm._v("mdi-chevron-down")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("v-expand-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: tech.active,
                                    expression: "tech.active"
                                  }
                                ],
                                staticClass: "mt-6"
                              },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _vm.getParameter(
                                          "isDisplayed",
                                          "nazov_predmetu",
                                          tech.pkid
                                        )
                                          ? _c("v-text-field", {
                                              staticClass:
                                                "dynamic-input-control",
                                              class: {
                                                required: _vm.getParameter(
                                                  "isRequired",
                                                  "nazov_predmetu",
                                                  tech.pkid
                                                )
                                              },
                                              attrs: {
                                                label: "Názov predmetu",
                                                disabled: !_vm.getParameter(
                                                  "isEnabled",
                                                  "nazov_predmetu",
                                                  tech.pkid
                                                ),
                                                rules: _vm.getParameter(
                                                  "isRequired",
                                                  "nazov_predmetu",
                                                  tech.pkid
                                                )
                                                  ? _vm.requiredRule
                                                  : [],
                                                outlined: ""
                                              },
                                              model: {
                                                value: tech.nazov_predmetu,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    tech,
                                                    "nazov_predmetu",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "tech.nazov_predmetu"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _vm.getParameter(
                                          "isDisplayed",
                                          "vyrobne_cislo",
                                          tech.pkid
                                        )
                                          ? _c("v-text-field", {
                                              staticClass:
                                                "dynamic-input-control",
                                              class: {
                                                required: _vm.getParameter(
                                                  "isRequired",
                                                  "vyrobne_cislo",
                                                  tech.pkid
                                                )
                                              },
                                              attrs: {
                                                label: "Výrobné číslo",
                                                disabled: !_vm.getParameter(
                                                  "isEnabled",
                                                  "vyrobne_cislo",
                                                  tech.pkid
                                                ),
                                                rules: _vm.getParameter(
                                                  "isRequired",
                                                  "vyrobne_cislo",
                                                  tech.pkid
                                                )
                                                  ? _vm.requiredRule
                                                  : [],
                                                outlined: ""
                                              },
                                              model: {
                                                value: tech.vyrobne_cislo,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    tech,
                                                    "vyrobne_cislo",
                                                    $$v
                                                  )
                                                },
                                                expression: "tech.vyrobne_cislo"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _vm.getParameter(
                                          "isDisplayed",
                                          "cena_bez_dph",
                                          tech.pkid
                                        )
                                          ? _c("numeric-text-box", {
                                              class: {
                                                required: _vm.getParameter(
                                                  "isRequired",
                                                  "cena_bez_dph",
                                                  tech.pkid
                                                )
                                              },
                                              attrs: {
                                                label: "Cena bez DPH",
                                                suffix: "€",
                                                isEnabled: _vm.getParameter(
                                                  "isEnabled",
                                                  "cena_bez_dph",
                                                  tech.pkid
                                                ),
                                                rules: _vm.getParameter(
                                                  "isRequired",
                                                  "cena_bez_dph",
                                                  tech.pkid
                                                )
                                                  ? _vm.requiredRule
                                                  : []
                                              },
                                              model: {
                                                value: tech.cena_bez_dph,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    tech,
                                                    "cena_bez_dph",
                                                    $$v
                                                  )
                                                },
                                                expression: "tech.cena_bez_dph"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _vm.getParameter(
                                          "isDisplayed",
                                          "rok_vyroby",
                                          tech.pkid
                                        )
                                          ? _c("v-text-field", {
                                              staticClass:
                                                "dynamic-input-control",
                                              class: {
                                                required: _vm.getParameter(
                                                  "isRequired",
                                                  "rok_vyroby",
                                                  tech.pkid
                                                )
                                              },
                                              attrs: {
                                                label: "Rok výroby",
                                                outlined: "",
                                                disabled: !_vm.getParameter(
                                                  "isEnabled",
                                                  "rok_vyroby",
                                                  tech.pkid
                                                ),
                                                rules: _vm.getParameter(
                                                  "isRequired",
                                                  "rok_vyroby",
                                                  tech.pkid
                                                )
                                                  ? _vm.requiredRule
                                                  : []
                                              },
                                              model: {
                                                value: tech.rok_vyroby,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    tech,
                                                    "rok_vyroby",
                                                    $$v
                                                  )
                                                },
                                                expression: "tech.rok_vyroby"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _vm.getParameter(
                                          "isDisplayed",
                                          "pocet_motohodin",
                                          tech.pkid
                                        )
                                          ? _c("numeric-text-box", {
                                              staticClass:
                                                "dynamic-input-control",
                                              class: {
                                                required: _vm.getParameter(
                                                  "isRequired",
                                                  "pocet_motohodin",
                                                  tech.pkid
                                                )
                                              },
                                              attrs: {
                                                label: "Počet motohodín",
                                                outlined: "",
                                                decimalPlaces: 0,
                                                isEnabled: _vm.getParameter(
                                                  "isEnabled",
                                                  "pocet_motohodin",
                                                  tech.pkid
                                                ),
                                                rules: _vm.getParameter(
                                                  "isRequired",
                                                  "pocet_motohodin",
                                                  tech.pkid
                                                )
                                                  ? _vm.requiredRule
                                                  : []
                                              },
                                              model: {
                                                value: tech.pocet_motohodin,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    tech,
                                                    "pocet_motohodin",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "tech.pocet_motohodin"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _vm.getParameter(
                                          "isDisplayed",
                                          "dovoz",
                                          tech.pkid
                                        )
                                          ? _c("v-checkbox", {
                                              staticClass: "dynamic_check_box",
                                              class: {
                                                required: _vm.getParameter(
                                                  "isRequired",
                                                  "dovoz",
                                                  tech.pkid
                                                )
                                              },
                                              attrs: {
                                                label: "Dovoz",
                                                disabled: !_vm.getParameter(
                                                  "isEnabled",
                                                  "dovoz",
                                                  tech.pkid
                                                ),
                                                rules: _vm.getParameter(
                                                  "isRequired",
                                                  "dovoz",
                                                  tech.pkid
                                                )
                                                  ? _vm.requiredRule
                                                  : [],
                                                "false-value": 0,
                                                "true-value": 1,
                                                outlined: ""
                                              },
                                              model: {
                                                value: tech.dovoz,
                                                callback: function($$v) {
                                                  _vm.$set(tech, "dovoz", $$v)
                                                },
                                                expression: "tech.dovoz"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _vm.getParameter(
                                          "isDisplayed",
                                          "vyrobca",
                                          tech.pkid
                                        )
                                          ? _c("v-text-field", {
                                              staticClass:
                                                "dynamic-input-control",
                                              class: {
                                                required: _vm.getParameter(
                                                  "isRequired",
                                                  "vyrobca",
                                                  tech.pkid
                                                )
                                              },
                                              attrs: {
                                                label: "Výrobca",
                                                disabled: !_vm.getParameter(
                                                  "isEnabled",
                                                  "vyrobca",
                                                  tech.pkid
                                                ),
                                                rules: _vm.getParameter(
                                                  "isRequired",
                                                  "vyrobca",
                                                  tech.pkid
                                                )
                                                  ? _vm.requiredRule
                                                  : [],
                                                outlined: ""
                                              },
                                              model: {
                                                value: tech.vyrobca,
                                                callback: function($$v) {
                                                  _vm.$set(tech, "vyrobca", $$v)
                                                },
                                                expression: "tech.vyrobca"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _vm.getParameter(
                                          "isDisplayed",
                                          "id_krajiny_povodu",
                                          tech.pkid
                                        )
                                          ? _c("v-autocomplete", {
                                              staticClass:
                                                "dynamic-input-control",
                                              class: {
                                                required: _vm.getParameter(
                                                  "isRequired",
                                                  "id_krajiny_povodu",
                                                  tech.pkid
                                                )
                                              },
                                              attrs: {
                                                "append-icon":
                                                  "mdi-chevron-down",
                                                outlined: "",
                                                label: "Krajina pôvodu",
                                                items: _vm.krajinyPovoduData,
                                                "item-text": "displayMember",
                                                "item-value": "valueMember",
                                                disabled: !_vm.getParameter(
                                                  "isEnabled",
                                                  "id_krajiny_povodu",
                                                  tech.pkid
                                                ),
                                                rules: _vm.getParameter(
                                                  "isRequired",
                                                  "id_krajiny_povodu",
                                                  tech.pkid
                                                )
                                                  ? _vm.requiredRule
                                                  : []
                                              },
                                              model: {
                                                value: tech.id_krajiny_povodu,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    tech,
                                                    "id_krajiny_povodu",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "tech.id_krajiny_povodu"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _vm.getParameter(
                                          "isDisplayed",
                                          "tech_sucast_nehnutelnosti",
                                          tech.pkid
                                        )
                                          ? _c("v-checkbox", {
                                              staticClass: "dynamic_check_box",
                                              class: {
                                                required: _vm.getParameter(
                                                  "isRequired",
                                                  "tech_sucast_nehnutelnosti",
                                                  tech.pkid
                                                )
                                              },
                                              attrs: {
                                                label:
                                                  "Technológia súčasťou nehnutelnosti",
                                                disabled: !_vm.getParameter(
                                                  "isEnabled",
                                                  "tech_sucast_nehnutelnosti",
                                                  tech.pkid
                                                ),
                                                rules: _vm.getParameter(
                                                  "isRequired",
                                                  "tech_sucast_nehnutelnosti",
                                                  tech.pkid
                                                )
                                                  ? _vm.requiredRule
                                                  : [],
                                                outlined: "",
                                                "false-value": 0,
                                                "true-value": 1
                                              },
                                              model: {
                                                value:
                                                  tech.tech_sucast_nehnutelnosti,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    tech,
                                                    "tech_sucast_nehnutelnosti",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "tech.tech_sucast_nehnutelnosti"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _vm.getParameter(
                                          "isDisplayed",
                                          "id_sposobu_nadobudnutia",
                                          tech.pkid
                                        )
                                          ? _c("v-autocomplete", {
                                              staticClass:
                                                "dynamic-input-control",
                                              class: {
                                                required: _vm.getParameter(
                                                  "isRequired",
                                                  "id_sposobu_nadobudnutia",
                                                  tech.pkid
                                                )
                                              },
                                              attrs: {
                                                "append-icon":
                                                  "mdi-chevron-down",
                                                outlined: "",
                                                label: "Spôsob nadobudnutia",
                                                items:
                                                  _vm.sposobyNadobudnutiaData,
                                                "item-text": "displayMember",
                                                "item-value": "valueMember",
                                                disabled: !_vm.getParameter(
                                                  "isEnabled",
                                                  "id_sposobu_nadobudnutia",
                                                  tech.pkid
                                                ),
                                                rules: _vm.getParameter(
                                                  "isRequired",
                                                  "id_sposobu_nadobudnutia",
                                                  tech.pkid
                                                )
                                                  ? _vm.requiredRule
                                                  : []
                                              },
                                              model: {
                                                value:
                                                  tech.id_sposobu_nadobudnutia,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    tech,
                                                    "id_sposobu_nadobudnutia",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "tech.id_sposobu_nadobudnutia"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _vm.getParameter(
                                          "isDisplayed",
                                          "dodavatel_id",
                                          tech.pkid
                                        )
                                          ? _c("v-autocomplete", {
                                              staticClass:
                                                "dynamic-input-control",
                                              class: {
                                                required: _vm.getParameter(
                                                  "isRequired",
                                                  "dodavatel_id",
                                                  tech.pkid
                                                )
                                              },
                                              attrs: {
                                                "append-icon":
                                                  "mdi-chevron-down",
                                                outlined: "",
                                                label: "Dodávateľ",
                                                items: tech.dodavateliaData,
                                                "item-text": "display_member",
                                                "item-value": "value_member",
                                                disabled: !_vm.getParameter(
                                                  "isEnabled",
                                                  "dodavatel_id",
                                                  tech.pkid
                                                ),
                                                rules: _vm.getParameter(
                                                  "isRequired",
                                                  "dodavatel_id",
                                                  tech.pkid
                                                )
                                                  ? _vm.requiredRule
                                                  : []
                                              },
                                              on: {
                                                "update:search-input": function(
                                                  newVal
                                                ) {
                                                  return _vm.searchDodavatel(
                                                    newVal,
                                                    tech
                                                  )
                                                }
                                              },
                                              model: {
                                                value: tech.dodavatel_id,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    tech,
                                                    "dodavatel_id",
                                                    $$v
                                                  )
                                                },
                                                expression: "tech.dodavatel_id"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm.jeAuto === true
            ? _c(
                "v-form",
                { ref: "formAuto", attrs: { autocomplete: "off" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "mt-6 card" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c("h2", { class: { "mb-6": _vm.showInfo } }, [
                            _vm._v("Doplnkové info")
                          ]),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-secondary ml-auto",
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  _vm.showInfo = !_vm.showInfo
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { class: { "rotate-180": _vm.showInfo } },
                                [_vm._v("mdi-chevron-down")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-expand-transition", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showInfo,
                                expression: "showInfo"
                              }
                            ]
                          },
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter("isDisplayed", "farba")
                                      ? _c("v-text-field", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "farba"
                                            )
                                          },
                                          attrs: {
                                            label: "Farba",
                                            outlined: "",
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "farba"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "farba"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value: _vm.preberaciProtokol.farba,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "farba",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.farba"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter("isDisplayed", "spz")
                                      ? _c("v-text-field", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "spz"
                                            )
                                          },
                                          attrs: {
                                            label: "EČV",
                                            outlined: "",
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "spz"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "spz"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value: _vm.preberaciProtokol.spz,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "spz",
                                                $$v
                                              )
                                            },
                                            expression: "preberaciProtokol.spz"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter("isDisplayed", "cislo_tp")
                                      ? _c("v-text-field", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "cislo_tp"
                                            )
                                          },
                                          attrs: {
                                            label: "Číslo veľkého TP",
                                            outlined: "",
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "cislo_tp"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "cislo_tp"
                                            )
                                              ? _vm.tpRule.concat(
                                                  _vm.requiredRule
                                                )
                                              : _vm.tpRule
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol.cislo_tp,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "cislo_tp",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.cislo_tp"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "id_ocenenie_vozidla"
                                    )
                                      ? _c("v-autocomplete", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "id_ocenenie_vozidla"
                                            )
                                          },
                                          attrs: {
                                            "append-icon": "mdi-chevron-down",
                                            outlined: "",
                                            label: "Ocenenie vozidla",
                                            items: _vm.oceneniaData,
                                            "item-text": "displayMember",
                                            "item-value": "valueMember",
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "id_ocenenie_vozidla"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "id_ocenenie_vozidla"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .id_ocenenie_vozidla,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "id_ocenenie_vozidla",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.id_ocenenie_vozidla"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter("isDisplayed", "vyrobca")
                                      ? _c("v-text-field", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "vyrobca"
                                            )
                                          },
                                          attrs: {
                                            label: "Výrobca",
                                            outlined: "",
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "vyrobca"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "vyrobca"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol.vyrobca,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "vyrobca",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.vyrobca"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "vymena_oleja"
                                    )
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "vymena_oleja"
                                            )
                                          },
                                          attrs: {
                                            label: "Výmena oleja",
                                            outlined: "",
                                            suffix: "km",
                                            decimalPlaces: 0,
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "vymena_oleja"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "vymena_oleja"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .vymena_oleja,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "vymena_oleja",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.vymena_oleja"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter("isDisplayed", "povod")
                                      ? _c("v-text-field", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "povod"
                                            )
                                          },
                                          attrs: {
                                            label: "Krajina pôvodu",
                                            outlined: "",
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "povod"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "povod"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value: _vm.preberaciProtokol.povod,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "povod",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.povod"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter("isDisplayed", "kontrola")
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "kontrola"
                                            )
                                          },
                                          attrs: {
                                            label: "Kontrola po",
                                            outlined: "",
                                            suffix: "km",
                                            decimalPlaces: 0,
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "kontrola"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "kontrola"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol.kontrola,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "kontrola",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.kontrola"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "najvacsia_pristupna_hmotnost"
                                    )
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "najvacsia_pristupna_hmotnost"
                                            )
                                          },
                                          attrs: {
                                            label: "Najväčšia príst. hmotn.",
                                            outlined: "",
                                            suffix: "kg",
                                            decimalPlaces: 0,
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "najvacsia_pristupna_hmotnost"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "najvacsia_pristupna_hmotnost"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .najvacsia_pristupna_hmotnost,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "najvacsia_pristupna_hmotnost",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.najvacsia_pristupna_hmotnost"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "datum_prihlasenia_di"
                                    )
                                      ? _c("date-picker", {
                                          attrs: {
                                            label: "Prihlásenie na DI",
                                            placeholder: "DD/MM/YYYY",
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "datum_prihlasenia_di"
                                            ),
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "datum_prihlasenia_di"
                                            )
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .datum_prihlasenia_di,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "datum_prihlasenia_di",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.datum_prihlasenia_di"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "hmotnost_uzitocna"
                                    )
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "hmotnost_uzitocna"
                                            )
                                          },
                                          attrs: {
                                            label: "Hmotnosť úžitková",
                                            outlined: "",
                                            suffix: "kg",
                                            decimalPlaces: 0,
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "hmotnost_uzitocna"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "hmotnost_uzitocna"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .hmotnost_uzitocna,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "hmotnost_uzitocna",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.hmotnost_uzitocna"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "hmotnost_pohotovostna"
                                    )
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "hmotnost_pohotovostna"
                                            )
                                          },
                                          attrs: {
                                            label: "Pohotovostná hmotnosť",
                                            outlined: "",
                                            suffix: "kg",
                                            decimalPlaces: 0,
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "hmotnost_pohotovostna"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "hmotnost_pohotovostna"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .hmotnost_pohotovostna,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "hmotnost_pohotovostna",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.hmotnost_pohotovostna"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "spotreba_mesto"
                                    )
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "spotreba_mesto"
                                            )
                                          },
                                          attrs: {
                                            label: "Spotreba v meste",
                                            outlined: "",
                                            suffix: "l/100 km",
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "spotreba_mesto"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "spotreba_mesto"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .spotreba_mesto,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "spotreba_mesto",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.spotreba_mesto"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "spotreba_mimo"
                                    )
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "spotreba_mimo"
                                            )
                                          },
                                          attrs: {
                                            label: "Spotreba mimo mesta",
                                            outlined: "",
                                            suffix: "l/100 km",
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "spotreba_mimo"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "spotreba_mimo"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .spotreba_mimo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "spotreba_mimo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.spotreba_mimo"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "spotreba_kombi"
                                    )
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "spotreba_kombi"
                                            )
                                          },
                                          attrs: {
                                            label: "Kombinovaná spotreba",
                                            outlined: "",
                                            suffix: "l/100 km",
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "spotreba_kombi"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "spotreba_kombi"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .spotreba_kombi,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "spotreba_kombi",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.spotreba_kombi"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "pocet_sedadiel"
                                    )
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "pocet_sedadiel"
                                            )
                                          },
                                          attrs: {
                                            label: "Počet sedadiel",
                                            outlined: "",
                                            decimalPlaces: 0,
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "pocet_sedadiel"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "pocet_sedadiel"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .pocet_sedadiel,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "pocet_sedadiel",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.pocet_sedadiel"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "cislo_motora"
                                    )
                                      ? _c("v-text-field", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "cislo_motora"
                                            )
                                          },
                                          attrs: {
                                            label: "Číslo motora",
                                            outlined: "",
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "cislo_motora"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "cislo_motora"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .cislo_motora,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "cislo_motora",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.cislo_motora"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "zaruka_motor_roky"
                                    )
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "zaruka_motor_roky"
                                            )
                                          },
                                          attrs: {
                                            label: "Záruka motora",
                                            outlined: "",
                                            suffix: "roky",
                                            decimalPlaces: 0,
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "zaruka_motor_roky"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "zaruka_motor_roky"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .zaruka_motor_roky,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "zaruka_motor_roky",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.zaruka_motor_roky"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "dohodnuty_poc_km_rok"
                                    )
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "dohodnuty_poc_km_rok"
                                            )
                                          },
                                          attrs: {
                                            label: "Dohodnutý počet km/rok",
                                            outlined: "",
                                            suffix: "km",
                                            decimalPlaces: 0,
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "dohodnuty_poc_km_rok"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "dohodnuty_poc_km_rok"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .dohodnuty_poc_km_rok,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "dohodnuty_poc_km_rok",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.dohodnuty_poc_km_rok"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "max_rychlost"
                                    )
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "max_rychlost"
                                            )
                                          },
                                          attrs: {
                                            label: "Maximálna rýchlosť",
                                            outlined: "",
                                            suffix: "km/h",
                                            decimalPlaces: 0,
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "max_rychlost"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "max_rychlost"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .max_rychlost,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "max_rychlost",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.max_rychlost"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "zaruka_karoseria"
                                    )
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "zaruka_karoseria"
                                            )
                                          },
                                          attrs: {
                                            label: "Záruka na karosériu",
                                            outlined: "",
                                            suffix: "roky",
                                            decimalPlaces: 0,
                                            isEnabled: _vm.getParameter(
                                              "isEnabled",
                                              "zaruka_karoseria"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "zaruka_karoseria"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .zaruka_karoseria,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "zaruka_karoseria",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.zaruka_karoseria"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "pocet_dveri"
                                    )
                                      ? _c("numeric-text-box", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "pocet_dveri"
                                            )
                                          },
                                          attrs: {
                                            label: "Počet dverí",
                                            outlined: "",
                                            decimalPlaces: 0,
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "pocet_dveri"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "pocet_dveri"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol.pocet_dveri,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "pocet_dveri",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.pocet_dveri"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "preferovany_servis"
                                    )
                                      ? _c("v-text-field", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "preferovany_servis"
                                            )
                                          },
                                          attrs: {
                                            label: "Preferovaný servis",
                                            outlined: "",
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "preferovany_servis"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "preferovany_servis"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .preferovany_servis,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "preferovany_servis",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.preferovany_servis"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "rozmer_diskov"
                                    )
                                      ? _c("v-autocomplete", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "rozmer_diskov"
                                            )
                                          },
                                          attrs: {
                                            "append-icon": "mdi-chevron-down",
                                            outlined: "",
                                            label: "Rozmer diskov",
                                            items: _vm.rozmeryDiskovData,
                                            "item-text": "displayMember",
                                            "item-value": "valueMember",
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "rozmer_diskov"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "rozmer_diskov"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .rozmer_diskov,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "rozmer_diskov",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.rozmer_diskov"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "id_sposobu_nadobudnutia"
                                    )
                                      ? _c("v-autocomplete", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "id_sposobu_nadobudnutia"
                                            )
                                          },
                                          attrs: {
                                            "append-icon": "mdi-chevron-down",
                                            outlined: "",
                                            label: "Spôsob nadobudnutia",
                                            items: _vm.sposobyNadobudnutiaData,
                                            "item-text": "displayMember",
                                            "item-value": "valueMember",
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "id_sposobu_nadobudnutia"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "id_sposobu_nadobudnutia"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .id_sposobu_nadobudnutia,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "id_sposobu_nadobudnutia",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.id_sposobu_nadobudnutia"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "rozmer_pneu"
                                    )
                                      ? _c("v-autocomplete", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "rozmer_pneu"
                                            )
                                          },
                                          attrs: {
                                            "append-icon": "mdi-chevron-down",
                                            outlined: "",
                                            label: "Rozmer pneu",
                                            items: _vm.rozmeryPneuData,
                                            "item-text": "displayMember",
                                            "item-value": "valueMember",
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "rozmer_pneu"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "rozmer_pneu"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol.rozmer_pneu,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "rozmer_pneu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.rozmer_pneu"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter("isDisplayed", "id_emisie")
                                      ? _c("v-autocomplete", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "id_emisie"
                                            )
                                          },
                                          attrs: {
                                            "append-icon": "mdi-chevron-down",
                                            outlined: "",
                                            label: "Emisie",
                                            items: _vm.emisieData,
                                            "item-text": "displayMember",
                                            "item-value": "valueMember",
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "id_emisie"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "id_emisie"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol.id_emisie,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "id_emisie",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.id_emisie"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _vm.getParameter(
                                      "isDisplayed",
                                      "id_ketegorie_vozidla"
                                    )
                                      ? _c("v-autocomplete", {
                                          staticClass: "dynamic-input-control",
                                          class: {
                                            required: _vm.getParameter(
                                              "isRequired",
                                              "id_ketegorie_vozidla"
                                            )
                                          },
                                          attrs: {
                                            "append-icon": "mdi-chevron-down",
                                            outlined: "",
                                            label: "Kategória vozidla",
                                            items: _vm.kategorieData,
                                            "item-text": "displayMember",
                                            "item-value": "valueMember",
                                            disabled: !_vm.getParameter(
                                              "isEnabled",
                                              "id_ketegorie_vozidla"
                                            ),
                                            rules: _vm.getParameter(
                                              "isRequired",
                                              "id_ketegorie_vozidla"
                                            )
                                              ? _vm.requiredRule
                                              : []
                                          },
                                          model: {
                                            value:
                                              _vm.preberaciProtokol
                                                .id_ketegorie_vozidla,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.preberaciProtokol,
                                                "id_ketegorie_vozidla",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "preberaciProtokol.id_ketegorie_vozidla"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-card",
                    { staticClass: "mt-6 card" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c("h2", { class: { "mb-6": _vm.showVybava } }, [
                            _vm._v("Výbava")
                          ]),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-secondary ml-auto",
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  _vm.showVybava = !_vm.showVybava
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { class: { "rotate-180": _vm.showVybava } },
                                [_vm._v("mdi-chevron-down")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-expand-transition", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showVybava,
                                expression: "showVybava"
                              }
                            ]
                          },
                          [
                            _c("v-data-table", {
                              staticClass: "standard-table",
                              attrs: {
                                headers: _vm.headers,
                                items: _vm.vybavaItems,
                                "show-select": "",
                                "item-key": "pkid"
                              },
                              on: {
                                "page-count": function($event) {
                                  _vm.pageCount = $event
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "item.data-table-select",
                                    fn: function(ref) {
                                      var isSelected = ref.isSelected
                                      var select = ref.select
                                      return [
                                        _c("v-simple-checkbox", {
                                          staticClass: "dynamic_check_box",
                                          attrs: {
                                            value: isSelected,
                                            ripple: false
                                          },
                                          on: {
                                            input: function($event) {
                                              return select($event)
                                            }
                                          }
                                        })
                                      ]
                                    }
                                  },
                                  {
                                    key: "item.nazov",
                                    fn: function(ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(" " + _vm._s(item.nazov) + " ")
                                      ]
                                    }
                                  },
                                  {
                                    key: "item.popis",
                                    fn: function(ref) {
                                      var item = ref.item
                                      return [
                                        _c("v-text-field", {
                                          staticClass:
                                            "dynamic-input-control dense",
                                          attrs: {
                                            dense: "",
                                            solo: "",
                                            "hide-details": "",
                                            label: "Vložte popis",
                                            outlined: ""
                                          },
                                          model: {
                                            value: item.popis,
                                            callback: function($$v) {
                                              _vm.$set(item, "popis", $$v)
                                            },
                                            expression: "item.popis"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.selected,
                                callback: function($$v) {
                                  _vm.selected = $$v
                                },
                                expression: "selected"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          !_vm.jeAuto
            ? _c(
                "div",
                { staticClass: "mt-20px", staticStyle: { display: "flex" } },
                [
                  _c("div", [_vm._v("Spolu: " + _vm._s(_vm.spolu) + "€")]),
                  _c("div", { staticStyle: { "margin-left": "20px" } }, [
                    _vm._v("Rozdiel: " + _vm._s(_vm.rozdiel) + "€")
                  ])
                ]
              )
            : _vm._e(),
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              !_vm.jeAuto
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { top: "", "close-delay": 0, "open-delay": 200 },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass: "btn-secondary mt-20px",
                                      on: {
                                        click: function($event) {
                                          return _vm.addTechnologia()
                                        }
                                      }
                                    },
                                    on
                                  ),
                                  [
                                    _c(
                                      "v-icon",
                                      { staticClass: "f18 mr-6px" },
                                      [_vm._v("mdi-upload-outline")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1785527753
                      )
                    },
                    [_c("span", [_vm._v("Pridať")])]
                  )
                : _vm._e(),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "btn-secondary mt-20px mr-20px right",
                  attrs: { to: "/obchodne-pripady" }
                },
                [_vm._v("Zatvoriť")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "btn-primary mt-20px",
                  attrs: { disabled: _vm.vinLoading },
                  on: {
                    click: function($event) {
                      return _vm.ulozit()
                    }
                  }
                },
                [_vm._v("Uložiť")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }